import React, { FC, useState } from 'react';
import Select, { StylesConfig, components } from 'react-select';

export interface Option {
    value: string;
    label: string;
}

interface DropdownProps {
    dropdownOptions: Array<Option>;
    placeholder: string;
    handleFormChange: (e: any) => void;
    defaultOption?: Option
    disabled?: boolean
}

const Dropdown: FC<DropdownProps> = ({ disabled, defaultOption, handleFormChange, dropdownOptions, placeholder }) => {

    const [selectedOption, setSelectedOption] = useState<Option | null>(defaultOption || null);
    const [isOpen, setIsOpen] = useState(false); // State to manage dropdown open/close

    const customStyles: StylesConfig<Option, false> = {
        control: (provided, state) => ({
            ...provided,
            borderColor: "#ccc", // Custom border color
            boxShadow: state.isFocused ? '0 0 0 1px green' : 'none', // Set shadow with green color when focused
            borderRadius: 8,
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#1B3445',  // Change placeholder text color
            fontSize: '16px',
            justifySelf: 'flex-start'
        }),
        singleValue: (base, props) => ({
            color: '#1B3445',  // Change placeholder text color
            fontSize: '16px',
            justifySelf: 'flex-start'
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            padding: 8,
            color: '#1B3445', // Change arrow color
            cursor: 'pointer', // Change cursor to pointer for better UX
        }),
        indicatorSeparator: () => ({
            display: 'none', // This removes the vertical line to the right of the dropdown arrow
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: 'white', // Change dropdown background color
            color: 'black', // Text color inside dropdown
            borderRadius: 8,
            borderColor: '#ccc', // Custom border color
            overflow: 'hidden'
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: 'white',
            color: 'black', // Text color for selected option
            '&:hover': {
                backgroundColor: 'white', // Background color when hovering over an option
            },
            fontWeight: state.data.value === "new_admin" ? "bold" : "normal",
            fontSize: '16px',
        borderRadius: 8,
        }),
        input: () => ({
            width: 0,
            height: 0,
            display: 'none', // Completely hides the input field (search functionality)
        }),
    };

    const handleChange = (option: Option | null) => {
        handleFormChange(option);
        setSelectedOption(option);
        console.log('Selected option:', option);
        setIsOpen(false); // Close dropdown on selection
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen); // Toggle dropdown open/close
    };

    const handleDropdownIndicatorClick = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent the event from bubbling up to the div
        setIsOpen(!isOpen); // Toggle dropdown open/close on arrow click
    };

    return (
        <div onClick={toggleDropdown} style={{ cursor: 'pointer' }}>
            <Select
                value={selectedOption}
                onChange={handleChange}
                options={dropdownOptions}
                placeholder={placeholder}
                isDisabled={disabled}
                styles={customStyles} // Apply custom styles
                menuIsOpen={isOpen} // Control dropdown open state
                onMenuClose={() => setIsOpen(false)} // Close the dropdown when it loses focus
                components={{
                    DropdownIndicator: (props) => (
                        <div onClick={handleDropdownIndicatorClick} style={{ cursor: 'pointer' }}>
                            <components.DropdownIndicator {...props} /> {/* Render the default arrow */}
                        </div>
                    ),
                }}
            />
        </div>
    );
}

export default Dropdown;
